import { UPLOAD_DOCUMENT_LOADING, UPLOAD_DOCUMENT_DONE, UPLOAD_DOCUMENT_ERROR,
  DOWNLOAD_REQUEST_INVOICE_LOADING, DOWNLOAD_REQUEST_INVOICE_DONE, DOWNLOAD_REQUEST_INVOICE_ERROR,
  DOWNLOAD_REQUEST_DETAIL_INVOICE_LOADING, DOWNLOAD_REQUEST_DETAIL_INVOICE_DONE, DOWNLOAD_REQUEST_DETAIL_INVOICE_ERROR,
  UPLOAD_COMPANY_DOCUMENT_LOADING, UPLOAD_COMPANY_DOCUMENT_DONE, UPLOAD_COMPANY_DOCUMENT_ERROR, VIEW_COMPANY_DOCUMENT_LOADING,
  VIEW_COMPANY_DOCUMENT_DONE, VIEW_COMPANY_DOCUMENT_ERROR, VERIFY_COMPANY_DOCUMENT_LOADING,
  VERIFY_COMPANY_DOCUMENT_DONE, VERIFY_COMPANY_DOCUMENT_ERROR
} from './actions'

export default {
  [UPLOAD_DOCUMENT_LOADING] (state) {
    state.isUploading = true
    state.errorUploading = false
    state.isUploaded = false
  },

  [UPLOAD_DOCUMENT_DONE] (state, items) {
    state.items = items
    state.isUploading = false
    state.errorUploading = false
    state.isUploaded = true
  },

  [UPLOAD_DOCUMENT_ERROR] (state, error) {
    state.errorUploading = true
    state.isUploading = false
    state.isUploaded = false
  },

  [UPLOAD_COMPANY_DOCUMENT_LOADING] (state) {
    state.isUploadingDoc = true
    state.errorUploadingDoc = false
    state.isUploadedDoc = false
  },

  [UPLOAD_COMPANY_DOCUMENT_DONE] (state, items) {
    state.items = items
    state.isUploadingDoc = false
    state.errorUploadingDoc = false
    state.isUploadedDoc = true
  },

  [UPLOAD_COMPANY_DOCUMENT_ERROR] (state, error) {
    state.errorUploadingDoc = true
    state.isUploadingDoc = false
    state.isUploadedDoc = false
  },

  [VIEW_COMPANY_DOCUMENT_LOADING] (state) {
    state.isLoadingGetDoc = true
    state.errorGetDoc = false
  },

  [VIEW_COMPANY_DOCUMENT_DONE] (state, items) {
    state.getDoc = items
    state.errorGetDoc = false
    state.isLoadingGetDoc = false
  },

  [VIEW_COMPANY_DOCUMENT_ERROR] (state, error) {
    state.errorViewingDoc = error
    state.getDoc = false
    state.isLoadingGetDoc = false
  },

  [VERIFY_COMPANY_DOCUMENT_LOADING] (state) {
    state.isLoadingVerifyDoc = true
    state.errorVerifyDoc = false
  },

  [VERIFY_COMPANY_DOCUMENT_DONE] (state, items) {
    state.verifyDoc = items
    state.errorVerifyDoc = false
    state.isLoadingVerifyDoc = false
  },

  [VERIFY_COMPANY_DOCUMENT_ERROR] (state, error) {
    state.errorVIEWingDoc = error
    state.verifyDoc = false
    state.isLoadingVerifyDoc = false
  },

  [DOWNLOAD_REQUEST_INVOICE_LOADING] (state) {
    state.isDownloading = true
    state.errorDownloading = false
  },

  [DOWNLOAD_REQUEST_INVOICE_DONE] (state) {
    state.isDownloading = false
    state.errorDownloading = false
  },

  [DOWNLOAD_REQUEST_INVOICE_ERROR] (state) {
    state.errorDownloading = true
    state.isDownloading = false
  },

  [DOWNLOAD_REQUEST_DETAIL_INVOICE_LOADING] (state) {
    state.isDownloading = true
    state.errorDownloading = false
  },

  [DOWNLOAD_REQUEST_DETAIL_INVOICE_DONE] (state) {
    state.isDownloading = false
    state.errorDownloading = false
  },

  [DOWNLOAD_REQUEST_DETAIL_INVOICE_ERROR] (state) {
    state.errorDownloading = true
    state.isDownloading = false
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/file/mutations.js